import { render, staticRenderFns } from "./poi-slideshow.vue?vue&type=template&id=50d13a20&scoped=true&"
import script from "./poi-slideshow.vue?vue&type=script&lang=js&"
export * from "./poi-slideshow.vue?vue&type=script&lang=js&"
import style0 from "./poi-slideshow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./poi-slideshow.vue?vue&type=style&index=1&id=50d13a20&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d13a20",
  null
  
)

export default component.exports